module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('Form_Element_Radio', {
		_setElement: function(elems) {
			this.formElement = elems;
		},

		/*_updateHandler: function() {
			//debugger;
			if (this.options.autoApply) {
				this.addDomHandler({target: this.formElement, event:'change', callback: 'changeHandler'}, 'changed');
			}
		},*/

		_setValue: function(value){
			fox.each(this.formElement, function(field, i) {
				if (field.value == value) {
					field.checked = true;
				}
			});

			return this;
		},

		getValue: function() {
			var val = null;

			fox.each(this.formElement, function(field, i) {
				field.checked == false;

				if (field.checked == true) {
					return val = field.value;
				}
			});

			return val;
		},

		changeHandler: function(elt, alias, scope, e) {
			if (elt.value != this.value) {
				this.setValue(elt.value);
			};
		},

		disable: function () {
			fox.each(this.formElement, function (el) {
				el.disabled = true;
			});

			this.isDisabled = true;
			this.dispatchEvent('disabled', this);
			return this; 
		},

		enable: function () {
			fox.each(this.formElement, function (el) {
				el.disabled = false;
			});
			
			this.isDisabled = false;
			this.dispatchEvent('enabled', this);
			return this; 
		},
	}, 'Form_Element');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/form/elements/radio.js
// module id = 195
// module chunks = 0